import {
    Check,
    ChevronDown,
} from "lucide-react";
import {
    useEffect,
    useRef,
    useState,
} from "react";

import {
    KycSelectOption,
} from "./KycPageData";

type KycSelectProps = {
    id: string;
    value: string;
    options: KycSelectOption[];
    placeholder: string;
    disabled?: boolean;
    onChange: (value: string) => void;
};

const KycSelect = ({
    id,
    value,
    options,
    placeholder,
    disabled = false,
    onChange,
}: KycSelectProps) => {
    const wrapperRef =
        useRef<HTMLDivElement>(
            null
        );

    const [
        open,
        setOpen,
    ] =
        useState(false);

    const selected =
        options.find(
            (option) =>
                option.value === value ||
                (value && option.label.toLowerCase() === value.toLowerCase()) ||
                (value && option.value.toLowerCase() === value.toLowerCase())
        );

    useEffect(
        () => {
            const handleOutside =
                (
                    event: MouseEvent
                ) => {
                    if (
                        wrapperRef.current &&
                        !wrapperRef.current.contains(
                            event.target as Node
                        )
                    ) {
                        setOpen(
                            false
                        );
                    }
                };

            const handleEscape =
                (
                    event: KeyboardEvent
                ) => {
                    if (
                        event.key ===
                        "Escape"
                    ) {
                        setOpen(
                            false
                        );
                    }
                };

            document.addEventListener(
                "mousedown",
                handleOutside
            );

            window.addEventListener(
                "keydown",
                handleEscape
            );

            return () => {
                document.removeEventListener(
                    "mousedown",
                    handleOutside
                );

                window.removeEventListener(
                    "keydown",
                    handleEscape
                );
            };
        },
        []
    );

    return (
        <div
            className="user-kyc-select"
            ref={
                wrapperRef
            }
        >
            <button
                id={
                    id
                }
                type="button"
                className={`user-kyc-select-trigger ${open
                        ? "open"
                        : ""
                    } ${disabled
                        ? "disabled"
                        : ""
                    }`}
                disabled={
                    disabled
                }
                onClick={() =>
                    setOpen(
                        (
                            previous
                        ) =>
                            !previous
                    )
                }
                aria-expanded={
                    open
                }
            >
                <span
                    className={
                        selected
                            ? "select-value"
                            : "select-placeholder"
                    }
                >
                    {selected
                        ? selected.label
                        : placeholder}
                </span>

                <ChevronDown
                    size={
                        16
                    }
                    strokeWidth={
                        2
                    }
                    className={
                        open
                            ? "rotate"
                            : ""
                    }
                />
            </button>

            {open && (
                <div className="user-kyc-select-menu">
                    {options.map(
                        (
                            option
                        ) => {
                            const active =
                                option.value ===
                                value;

                            return (
                                <button
                                    type="button"
                                    className={`user-kyc-select-option ${active
                                            ? "selected"
                                            : ""
                                        }`}
                                    key={
                                        option.value
                                    }
                                    onClick={() => {
                                        onChange(
                                            option.value
                                        );

                                        setOpen(
                                            false
                                        );
                                    }}
                                >
                                    <span>
                                        {
                                            option.label
                                        }
                                    </span>

                                    {active && (
                                        <Check
                                            size={
                                                15
                                            }
                                            strokeWidth={
                                                2.4
                                            }
                                        />
                                    )}
                                </button>
                            );
                        }
                    )}
                </div>
            )}
        </div>
    );
};

export default KycSelect;
